var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"serve-wrapper",class:{ 'need-margin': _vm.needMargin }},_vm._l((_vm.items),function(service,i){return _c('serviceItem',{key:service.id,attrs:{"service":service,"index":i}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }